'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$0024 from "./presto.-Login-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445 from "./presto.-Presto-Router$$anon$45.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$44() {
  this.biG = null;
  this.biy = null;
  this.biz = false;
  this.biH = null;
  this.biI = false;
  this.biL = null;
  this.biE = null;
  this.biF = false;
  this.biA = null;
  this.biB = false;
  this.biC = null;
  this.biD = false;
  this.biJ = false;
  this.biK = false;
  this.biG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.biL = "LoginPage";
}
export { $c_Lpresto_PrestoRouter$$anon$44 as $c_Lpresto_PrestoRouter$$anon$44 };
$p = $c_Lpresto_PrestoRouter$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$44;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$44() {
}
export { $h_Lpresto_PrestoRouter$$anon$44 as $h_Lpresto_PrestoRouter$$anon$44 };
$h_Lpresto_PrestoRouter$$anon$44.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.biG;
});
$p.L = (function() {
  if ((!this.biz)) {
    this.biy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biz = true;
  }
  return this.biy;
});
$p.O = (function() {
  if ((!this.biI)) {
    this.biH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.biI = true;
  }
  return this.biH;
});
$p.E = (function() {
  return this.biL;
});
$p.t = (function() {
  if ((!this.biF)) {
    this.biE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biF = true;
  }
  return this.biE;
});
$p.M = (function() {
  if ((!this.biB)) {
    this.biA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biB = true;
  }
  return this.biA;
});
$p.Q = (function() {
  if ((!this.biD)) {
    this.biC = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445.$c_Lpresto_PrestoRouter$$anon$45();
    this.biD = true;
  }
  return this.biC;
});
$p.w = (function() {
  if ((!this.biK)) {
    this.biJ = false;
    this.biK = true;
  }
  return this.biJ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee370) => ((p) => \u03b4scrutinee370))($j_presto$002e$002dLogin$002dPage$0024.$m_Lpresto_LoginPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$44, "presto.PrestoRouter$$anon$44", ({
  Oa: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$44 as $d_Lpresto_PrestoRouter$$anon$44 };
//# sourceMappingURL=presto.-Presto-Router$$anon$44.js.map
